
<template>
    <div id="markupsApp" style="height: 100%; position: relative; overflow: hidden;">
        <markups-popup></markups-popup>
    </div>
</template>
<script>    
import { createMarkupsApp } from '@/scripts/Markups/Markups'
import appConfig from "../../appConfig";
const realityStyles = () => appConfig.IS_FABRICATION ? import('@/styles/Markups/fabrication-styles.css') : import('@/styles/Markups/reality-styles.css')
const connectStyles = () => import('@/styles/Markups/connect-styles.css')
const originStyles = () => import('@/styles/Markups/origin-styles.css')
export default {
    name: 'MarkupsView',
    components: {
        'markups-popup': () => import('@/components/markups/markupsPopup.vue')
    },
    methods: {
        // eslint-disable-next-line no-debugger
        useTargetStyle() {
            var urlSearchParams = new URLSearchParams(window.location.search);
            var params = Object.fromEntries(urlSearchParams.entries());
            var parent = params["type"]?.toLowerCase();
            if (parent && parent != '') {
                if (parent.includes('reality')) {
                    realityStyles()
                    // require('@/styles/Markups/reality-styles.css')
                } else if (parent.includes('connect')) {
                    connectStyles()
                    // require('@/styles/Markups/connect-styles.css')
                } else if (parent.includes('origin')) {
                    originStyles()
                    // require('@/styles/Markups/origin-styles.css')
                }
            }
        }
    },
    mounted: function () {
        this.$store.state.markupsApp = this;
        this.useTargetStyle();
        createMarkupsApp()
    }
}
</script>